// import { getCookie } from 'shared/utils/cookies';
import {
  KoLoader,  KoText, KoTitle,
  // KoEngagementCalendar,
  KoDP,
  KoCalendar
  // KoCharts
} from 'packages';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import { DevelopmentAPI } from '../development.service';
import styles from './timeline.module.scss';
// import BookingList from './bookingList';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
// import EventBookingTrendChart from './eventBookingTrendChart';

export default function TaskCalendar() {
  const dispatch = useDispatch();
  let { workspaceId } = useParams();
  const currentAssignees = useSelector(state => state?.currentAssignees);
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const userData = currentAssignees['data'] || [];
  const [isBookingList, setBookingList] = useState();
  const [copy, setCopy] = useState(false);
  // let accountId = getCookie('accountId');

  useEffect(()=>{
    dispatch(remove());
    dispatch(add([]));
  },[]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copy) setCopy(false);
    }, 800);

    return () => clearTimeout(timeout);
  }, [copy]);

  useEffect(() => {
    if(currentAssignees){
      getAllBookings(currentAssignees['data'][0]);
    }
  },[currentAssignees]);

  // const onCopyLink=(data)=>{
  //   setCopy(true);
  //   navigator.clipboard.writeText(`${window.location.origin}/open/calendar/${accountId}/${data?.eventId}/${data?.createdBy}`);
  // };

  const getAllBookings = (user) => {
    if(!user?.userId) return;
    setBookingList();
    setLoading(true);
    setCurrentRecord(user);
    DevelopmentAPI.getMeetings(workspaceId, user?.userId ).then(
      (data) => {
        setBookingList(data?.meetings);
        
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}

      <div className={styles.container}>
        <div className={styles.eventList}>
          <div className={styles.header}>
            <KoTitle text={`Team Members`} level={5} />
          </div>
          <div className={styles.eventsWrapper}>
            {userData?.map((user, i) =><div key={user?.userId} className={`${styles.event} ${currentRecord?.userId === user?.userId ? styles.active : ''}`} onClick={() => { getAllBookings(user); }}>
              <div className={`${styles.eventHeader} calendarEngagement`}>
                <KoDP name={user?.profile?.firstName} logo={user?.profile?.logo} width={30} height={30} />
              </div>
              <div className={styles.userProfile}>
                <KoText ellipsis={true} className={`${styles.title}`} text={`${user?.profile?.firstName} ${user?.profile?.lastName}`} />
                <KoText ellipsis={true} className={`${styles.description}`} text={user?.email ? user?.email : 'Dont miss scheduled events'} />
              </div>
            </div>)}
          </div>
        </div>
        {isBookingList && <KoCalendar top={256} gridHeight={styles.gridHeight} isInfoView={false} onEditMeeting={(record) => {setCurrentRecord(record);}} onDeleteMeeting={(record) => {setCurrentRecord(record);}} meetings={isBookingList} />}
        {/* 
        <div className={styles.calendarWrapper}>

          <div className={styles.calendarWrapperTitle}>
            <div className={styles.headerWithActions}>
              <KoTitle text={`${currentRecord?.profile?.firstName} ${currentRecord?.profile?.lastName}`} level={4} />
              <div className={styles.actions}>
              </div>
            </div>
            <div className={styles.headrDescriptionWrapper}>
              <div className={styles.headrDescription}>
                <KoDescription className={styles.small} text={`${currentRecord?.email ? currentRecord?.email : 'Dont miss scheduled events'}`} />
              </div>
              <div className={styles.activityTypes}>
                
              </div>
            </div>
          </div>
          <div className={styles.calendarContainer}>
            <div className={styles.eventInformation}>
              {isBookingList?.length > 0 ? <BookingList meetings={isBookingList} /> :   <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
                <KoEmpty label="Create Event" icon={'EmptyTwoTone'} title="Create a new event"/>
              </KoFlex>}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
